var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.toast.visible)?_c('div',{staticClass:"alert",class:("alert-" + (_vm.toast.variant))},[_c('h6',[_vm._v(_vm._s(_vm.toast.title))]),_c('small',[_vm._v(_vm._s(_vm.toast.text))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }